/** URL of the Cloudflow frame CGI running on the user's machine. */
const FRAME_CGI_URL = 'http://127.0.0.1:9091/frameCGI/frame.cgi';

/**
 * Sends a command to the local Cloudflow frame CGI (open a folder or a file on the user's machine).
 * Same request as the former `jQuery.ajax` call: a CORS "simple" POST, fire and forget.
 */
export function callFrameCgi(command: Record<string, any>): void {
    fetch(FRAME_CGI_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain; charset=UTF-8' },
        body: JSON.stringify(command),
    }).catch(() => undefined);
}

/** `src` attribute of the element with this id, like `jQuery('#id').attr('src')`. */
export function getSrc(id: string): string | undefined {
    return document.getElementById(id)?.getAttribute('src') ?? undefined;
}

/**
 * Sets the `src` attribute of the element with this id, like `jQuery('#id').attr('src', value)`:
 * `undefined` leaves it unchanged and `null` removes it.
 */
export function setSrc(id: string, value: string | null | undefined): void {
    const element = document.getElementById(id);
    if (!element || value === undefined) {
        return;
    }
    if (value === null) {
        element.removeAttribute('src');
    } else {
        element.setAttribute('src', String(value));
    }
}

/** Downloads a Blob under this file name (replaces `saveAs` from file-saver). */
export function saveBlob(blob: Blob, filename: string): void {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.rel = 'noopener';
    document.body.appendChild(link);
    link.click();
    link.remove();
    // Same delay as file-saver before releasing the object URL, so slow downloads can still start.
    setTimeout(() => URL.revokeObjectURL(url), 40_000);
}
